<template>
    <v-card class="chat-room">
      <v-toolbar color="primary" class="chat-room--toolbar" flat dark dense>
        <v-toolbar-title class="white--text">
          {{worklistItem.supplierQuotationNo}}&emsp;&emsp;{{worklistItem.requestNo}}
        </v-toolbar-title>
        <v-spacer></v-spacer>

        <v-menu offset-y>
          <v-btn icon slot="activator">
            <v-icon>
              apps
            </v-icon>
          </v-btn>

          <v-list>
            <v-list-tile v-if="isAdmin || isManager" @click="statistics" avatar>
              <v-list-tile-content>
                <v-list-tile-title>
                  Statistics
                </v-list-tile-title>
              </v-list-tile-content>

              <v-list-tile-avatar>
                <v-icon>
                  stacked_bar_chart
                </v-icon>
              </v-list-tile-avatar>
            </v-list-tile>

            <v-list-tile @click="manageUsers" avatar>
              <v-list-tile-content>
                <v-list-tile-title>
                Users
                </v-list-tile-title>
              </v-list-tile-content>

              <v-list-tile-avatar>
                <v-icon>
                  group
                </v-icon>
              </v-list-tile-avatar>
            </v-list-tile>

            <v-list-tile v-if="isAdmin  || isManager" @click="msgks">
              <v-list-tile-content>
                <v-list-tile-title>
                  MSGKs
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile v-if="isAdmin  || isManager" @click="suppliers">
              <v-list-tile-content>
                <v-list-tile-title>
                  Suppliers
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile v-if="isAdmin" @click="logs">
              <v-list-tile-content>
                <v-list-tile-title>
                  Logs
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile v-if="isAdmin" @click="settings">
              <v-list-tile-content>
                <v-list-tile-title>
                  General Settings
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile v-if="isAdmin" @click="feedbacks">
              <v-list-tile-content>
                <v-list-tile-title>
                  Feedbacks
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-menu>
        <template v-if="isAdmin">
           <v-menu offset-y>
            <v-btn @click="showModal('filter')" depressed
              slot="activator"
              color="primary"
              dark>
              Filter
            </v-btn>
          </v-menu>
          <v-menu offset-y>
            <v-btn @click="dumpDB" depressed
              slot="activator"
              color="primary"
              dark>
              Download Nego DB
            </v-btn>
          </v-menu>
          <v-menu offset-y>
            <v-btn @click="dumpVendor" depressed
              slot="activator"
              color="primary"
              dark>
              Download Vendor Stat
            </v-btn>
          </v-menu>
        </template>
        <template v-if="isAdmin && isTest">
          <v-menu offset-y>
            <v-btn @click="showModal('upload')"
              depressed
              slot="activator"
              color="primary"
              dark>
              Upload
            </v-btn>
          </v-menu>
        </template>
        <v-menu offset-y>
          <v-btn
            depressed
            slot="activator"
            color="primary"
            dark
          >
            Download Chat
          </v-btn>
          <v-list>
            <v-list-tile
              v-for="(item, index) in downloadOptions"
              :key="index"
              :href=item.href
              :download="worklistItem.requestNo + '.' + item.title"
            >
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
        <v-btn icon @click="reload">
          <v-icon>refresh</v-icon>
        </v-btn>
        <v-btn icon @click="handleFullScreen()">
          <v-icon>fullscreen</v-icon>
        </v-btn>
        <v-btn icon @click="logout()">
          <v-icon>exit_to_app</v-icon>
        </v-btn>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="[worklistItem]"
        hide-actions
        v-if="uuid"
      >
        <template slot="items" slot-scope="props">
          <td v-for="header in headers" :key="header.text">
            <template v-if="props.item[header.value] == '' || !props.item[header.value]">
              -
            </template>
            <template v-else>
          {{ props.item[header.value] }}
          </template>
          </td>
        </template>
      </v-data-table>
        <v-btn color="secondary" v-if="uuid" depressed @click="toggleAdvancedFilter()">
          Advanced filter
        </v-btn>
        <template v-if="advancedFilter">
          <v-btn color="primary" @click="advancedFiltering()">
            Filter
            <v-icon right>filter_list</v-icon>
          </v-btn>
          <v-btn v-if="advancedReset" color="primary" class="right" @click="resetAdvancedFilter()">
            Reset filters
            <v-icon right>replay</v-icon>
          </v-btn>
        <v-toolbar color="secondary" class="empty-stats--toolbar" height=10px flat dark dense>
        </v-toolbar>
      <v-data-table 
        :headers="advancedHeaders"
        :items="[worklistItem]"
        hide-actions
        v-if="uuid">
        <template slot="items">
        <td v-for="header in advancedHeaders" :key="header.text">
          <template>
            <template v-if="header.filterType == 'number'">
              <v-select @input="showResetButton()" v-model="header.filterOperation" dense flat :items="operationTypes" label="operation" style="width:85px; height:60px" ></v-select>
              <v-text-field class="num" @input="showResetButton()" :min="0" :step="100" v-model="header.filterValue" type="number" label="value" style="width:85px; height:60px"></v-text-field>
            </template>
            <template v-else-if="header.filterType == 'text'">
              <div style="width:85px;height:60px"></div>
              <v-text-field @input="showResetButton()" v-model="header.filterValue" label="value" style="width:85px; height:60px"></v-text-field>
            </template>
            <template v-else>
              <div style="width:85px;height:120px"></div>
            </template>
          </template>
        </td>
        </template>
      </v-data-table>
      <v-toolbar color="secondary" class="empty-stats--toolbar" height=10px flat dark dense>
        </v-toolbar>
      </template>
      <vue-perfect-scrollbar v-if="uuid" class="chat-room--scrollbar grey lighten-5" v-bind:style="computeHeight" ref="scroll">
        <v-card-text class="chat-room--list pa-3" v-if="uuid">
          <template v-for="(item, index) in messages">
            <div v-if="item.userMessage" class="messaging-item layout row my-3" :key="'user_' + index" style="display: inline-flex">
              <v-avatar class="primary mx-1" size="40">
                <span class="white--text headline">U</span>
              </v-avatar>
              <div class="messaging--body layout column mx-2">
                <p :value="true" class="chat-room--userbubble grey lighten-3 black--text pa-2 msg-radius pre-line">{{item.userMessage}}</p>
                <div class="caption px-2 text--secondary">{{formatChatTime(item.userTimestamp)}} Bot: {{item.botPrice}}€  User: {{item.userPrice}}€</div>
              </div>
            </div>
            <template v-if="item.botMessage[0]">
            <div  v-for="(text, index) in getMessagesfromBot(item.botMessage)" :key="'bot_' + index + formatChatTime(item.botTimestamp)" class="reverse messaging-item layout row my-3">
              <div class="reverse messaging-item layout row my-3" style="display: inline-flex">
                <v-avatar class="secondary mx-1" size="40">
                  <span class="white--text headline">N</span>
                </v-avatar>
                <div v-if="item.botMessage[0]" class="messaging--body layout column mx-2">
                  <p :value="true" class="chat-room--botbubble secondary white--text pa-2 msg-radius pre-line">{{text}}</p>
                  <div v-if="item.botTimestamp" class="caption px-2 text--secondary">{{formatChatTime(item.botTimestamp)}} Bot: {{item.botPrice}}€  User: {{item.userPrice}}€</div>
                </div>
                <v-spacer></v-spacer>
              </div>
            </div>
            </template>
          </template>
          <v-container v-if="messages.length===0" class="chat-room--scrollbar text-md-center justify-center" fill-height>
            <div class="messaging-item">
              <p class="elevation-4 chat-room--userbubble grey lighten-3 black--text pa-2 msg-radius">
                  Keine Nachrichten vorhanden
              </p>
            </div>
          </v-container>
        </v-card-text>
      </vue-perfect-scrollbar>
      <v-container v-else class="text-md-center justify-center" style="height:100vh" fill-height>
        <div class="messaging-item">
          <p class="elevation-4 chat-room--userbubble grey lighten-3 black--text pa-2 msg-radius">
              Wähle einen Chat aus
          </p>
        </div>
      </v-container>
      <modal name="upload">
        <div class="theme--dark primary white--text font-weight-bold d-flex justify-center align-center" style="height:20%">
            Upload new file
        </div>
        <form @submit.prevent="onSubmit" enctype= multipart/form-data>
        <div class="d-flex justify-center align-center" style="height:60%">
          <label for="inputFile" class="d-flex justify-center align-center" style="height:50%">
            <div id="nameOfFile" class="primary--text pa-2 ma-2 text-md-center" style="width:50%">No file selected</div>
            <strong style="border:7pt solid black; width:50%" class="primary--text pa-2 ma-2 text-md-center">Select a file</strong>
          </label>
          <input type="file" name="inputFile" id="inputFile" ref="file" hidden @change="onSelect">
        </div>
        <div class="text-md-right" style="height:20%">
        <v-btn @click="onSubmit" color="primary" dark>
            Upload
        </v-btn>
        </div>
        <div class="text-md-right" style="height:20%">
              <a v-bind:href="uploadResultUrl">{{uploadResult}}</a>
             <h5>{{errorMessage}}</h5>        
        </div>
        </form>  

      </modal>

      <modal name="filter" height=auto>
        <vue-perfect-scrollbar class="chat-history--scrollbar">
        <div class="theme--dark primary white--text font-weight-bold d-flex justify-center align-center" style="height:10%">
            Choose filters
        </div> 
        <div style="padding:2%">
          <div style="height:72%">
            <div class="d-flex ">
            <div class="picker">
              Date From:
            </div>
            <div class="picker">
              Date To:
            </div>
            </div>
            <template>
              <date-pick class="picker" v-model="downloadFilter.fromDate" :hasInputElement="false"></date-pick>
            </template>
            <template>
              <date-pick class="picker" v-model="downloadFilter.toDate" :hasInputElement="false"></date-pick>
            </template>
          <div class="d-flex">
          <v-select eager name="status" label="status" v-on:change="pickSubStatus" item-text="name"  item-value="name"  v-model="downloadFilter.status"  :items="statuses"></v-select>
          <v-select  v-if="showSubStatusesSelector" name="subStatus" label="substatus" item-text="name" item-value="name" v-model="downloadFilter.subStatus" :items="subStatusesItems"></v-select>
          </div>
          <v-select eager name="language" label="language" v-on:change="pickSubStatus" item-text="name"  item-value="value"  v-model="downloadFilter.language"  :items="languages"></v-select>

          <v-select name="dept" label="department" v-on:change="changeTeams"  v-model="downloadFilter.dept"  :items="departments"></v-select>
          <v-select name="team" label="team"  item-text="name"  item-value="id"  v-model="downloadFilter.team"  :items="teams"></v-select>

          <div class="d-flex">
             <v-select  name="paymentTermCurrent" label="Current payment term" item-text="paymentTerm"  item-value="paymentTerm" v-model="downloadFilter.paymentTermCurrent"  :items="paymentTerms"></v-select>
             <v-select  name="paymentTermFinal" label="Final payment term" item-text="paymentTerm"  item-value="paymentTerm" v-model="downloadFilter.paymentTermFinal" :items="paymentTerms"></v-select>
          </div>
          <div class="d-flex">
             <v-select  name="fallback" label="Default fallback trigered" item-text="name"  item-value="value" v-model="downloadFilter.fallback"  :items="fallback"></v-select>
          </div>
          <v-btn @click="filterWorklists" color="primary" dark>
              Filter
          </v-btn>
          <v-btn @click="filterWorklistsReset" color="primary" dark>
              Reset Filter
          </v-btn>
        </div>
        </div>
        </vue-perfect-scrollbar>
      </modal>
    </v-card>
</template>
<script>
import API from '@/api'
import axios from 'axios'
import { backendUrl } from '../../../config/config.js'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import VWidget from '@/components/VWidget'
import Util from '@/util'
import DatePick from 'vue-date-pick';
import 'vue-date-pick/dist/vueDatePick.css';
import TeamsJson from '../../pages/teams.json'
TeamsJson.push({
      id: "ALL",
      name: "ALL"
    })

export default {
  data: () => ({
    advancedFilter:false,
    advancedReset:false,
    operationTypes:["=", ">", "<"],
    teamsDept: TeamsJson,
    teams: [],
    departments : [],
    worklistItem: {},
    uploadResult : '',
    uploadResultUrl : '',
    errorMessage : '',
    uuid: '',
    sessionId: '',
    agentMessage: '',
    messages: [],
    rightDrawer: false,
    headers: [ 
              {text: "SupplierQuotationNo", value: "supplierQuotationNo", sortable: false},
              {text: "RequestNo", value: "requestNo", sortable: false},
              {text: "MaterialGrp", value: "materialGrp", sortable: false},
              {text: "TotalValue", value: "totalValue", sortable: false},
              {text: "StartingPrice", value: "startingPrice", sortable: false},
              {text: "TargetPrice", value: "targetPrice", sortable: false},
              {text: "Currency", value: "currency", sortable: false},
              {text: "NegotiationLanguage", value: "languageCode", sortable: false},
              {text: "NegotiationLink", value: "negotiationLink", sortable: false},
              {text: "FinalPrice", value: "finalPrice", sortable: false},
              {text: "Savings", value: "savings", sortable: false},
              {text: "NegotiationStatus", value: "negotiationStatus", sortable: false},
              {text: "NegotiationSubStatus", value: "negotiationSubStatus", sortable: false},
              {text: "NegotiationChatViewLink", value: "negotiationChatViewLink", sortable: false},
              {text: "Team", value: "team", sortable: false},
              {text: "DesiredVendor", value: "desiredVendor", sortable: false},
              {text: "UUID", value: "UUID", sortable: false},
              {text: "SessionId", value: "sessionId", sortable: false},
              {text: "MaxIterations", value: "maxIterations", sortable: false},
              {text: "NegotiationLogic", value: "negotiationLogic", sortable: false},
              {text: "PaymentTermCurrent", value: "paymentTermCurrent", sortable: false},
              {text: "PaymentTermFinal", value: "paymentTermFinal", sortable: false},
              {text: "PaymentNegotiation", value: "paymentNego", sortable: false},              
              {text: "CompanyCode", value: "companyCode", sortable: false},
              {text: "EmailID", value: "emailID", sortable: false},
              {text: "Feedback", value: "feedback", sortable: false}
              ],
    advancedHeaders: [
              {text: "SupplierQuotationNo", value: "supplierQuotationNo", sortable: false, filterType:"text", filterValue:""},
              {text: "RequestNo", value: "requestNo", sortable: false, filterType:"text", filterValue:""},
              {text: "MaterialGrp", value: "materialGrp", sortable: false, filterType:"text", filterValue:""},
              {text: "TotalValue", value: "totalValue", sortable: false, filterType:"number", filterOperation:"", filterValue:""},
              {text: "StartingPrice", value: "startingPrice", sortable: false, filterType:"number", filterOperation:"", filterValue:""},
              {text: "TargetPrice", value: "targetPrice", sortable: false, filterType:"number", filterOperation:"", filterValue:""},
              {text: "FinalPrice", value: "finalPrice", sortable: false, filterType:"number", filterOperation:"", filterValue:""},
              {text: "Savings", value: "savings", sortable: false, filterType:"number", filterOperation:"", filterValue:""}
    ],
    downloadOptions: [
      {
        title: 'JSON',
        href: '',
      },
      {
        title: 'TXT',
        href: '',
      }
    ],
    downloadFilter: {
      toDate: new Date().toISOString().split("T")[0],
      fromDate: new Date().toISOString().split("T")[0],
      dept:'ALL',
      status:'ALL',
      subStatus:'ALL',
      team:'ALL',
      fallback:'ALL'
    },
    statuses : [
      { name: "ALL"}
    ],
    languages : [
      { name: "ALL", value:"ALL"},
      { name: "German", value:"de-DE"},
      { name: "English", value:"en-EN"}
    ],
    subStatuses : [],
    paymentTerms : [],
    fallback : [ 
      {value: "ALL", name:"ALL"},
      {value: 0, name:"0 fallbacks"},
      {value: 3, name:"1-3 fallbacks"},
      {value: 4, name:"4+ fallbacks"}],
    showSubStatusesSelector: false,
    subStatusesItems: [],
  }),
  mounted () {
    this.uuid = this.$route.params.uuid;
    this.updateMessages();
    this.prepareDownload(this.$route.params.uuid);
    var today = new Date();
    today.setDate(today.getDate() - 30);
    this.downloadFilter.fromDate = today.toISOString().split("T")[0];
    API.getStatuses().then(subStatuses => {
      this.subStatuses = subStatuses;
      for (const property in subStatuses) {
        this.statuses.push({name: property});
      }
    });

    API.getPayments().then(paymentTerms  => {
      this.paymentTerms = paymentTerms;      
    });
 

    this.departments.push("All");
        for(let i = 0; i < this.teamsDept.length; i++) {    
            if(this.teamsDept[i].dept && !this.departments.includes(this.teamsDept[i].dept)) {
                this.departments.push(this.teamsDept[i].dept);
            }
        }
  },
  watch: {
    $route (to, from) {
      this.uuid = to.params.uuid
      this.updateMessages()
      this.prepareDownload(this.$route.params.uuid)
      this.resetAdvancedFilter()
      this.$refs.scroll.$el.scrollTop = 0;
    }
  },
  components: {
    VWidget,
    VuePerfectScrollbar,
    DatePick
  },
  props: {
    height: {
      type: String,
      default: null
    }
  },
  computed: {
    computeHeight () {
      return {
        height: this.height || ''
      }
    },
    isAdmin() {
      if (localStorage.getItem("role") &&  localStorage.getItem("role").toLowerCase() === 'admin') {
        return true;
      } else {
        return false;
      }
    },
    isManager() {
      console.log(localStorage.getItem("role"));
      if (localStorage.getItem("role") &&  localStorage.getItem("role").toLowerCase() === 'management') {
        return true;
      } else {
        return false;
      }
    },
    isTest() {
      console.log(backendUrl);
      if(backendUrl.includes("localhost") || backendUrl.includes("dev")) {
        return true;
      } else {
        return false;
      }      
    }
  },
  methods: {
    firstLetter (name) {
      return name.charAt(0)
    },
    // fetch information about one worklist entry
    async getWorklistById () {
      if (this.uuid) {
        this.worklistItem = await API.getWorklistById(this.uuid)
        if(this.worklistItem) {
          this.sessionId = this.worklistItem.sessionId
        } else {
          this.worklistItem = {}
      	}


      } else {
        this.worklistItem = {}
      }
    },
    // fetch all messages for given sessionId
    async updateMessages () {
      await this.getWorklistById()
      if (this.uuid && this.sessionId) {
        this.messages = await API.getMessagesById(this.sessionId)
      } else {
        this.messages = []
      }
    },
    // extract text from different answer types of bot
    getMessagesfromBot(botMessage) {      
      const result = []
      
      botMessage.forEach(message => {
        if (message.text){
          message.text.text != '' ? result.push(message.text.text[0]): false;
        } else if (message.card) {
          result.push(message.card.title + "\r\n" + message.card.subtitle )
        } else if (message.quickReplies) {
          result.push(message.quickReplies.title)
        }       
      });

      
      return result
    },
    // display date and time below messages
    formatChatTime (s) {
      if (typeof(s) === 'string') {
        var t = new Date(s) 
        var out = t.toLocaleString()
      } else if (typeof(s) === 'object') {
        var t = new Date(1970, 0, 1) 
        t.setSeconds(s._seconds)
        var out = t.toLocaleString()
      }
      return out
    },
    handleFullScreen () {
      Util.toggleFullScreen()
    },
    reload () {
      window.location.reload()
    },
    // fetch information to be provided as downloadable in toolbar
    async download(datatype, uuid) {
      var outString = ''
      if (datatype === 'JSON') {
        const result = await API.exportJSON(uuid)
        outString = JSON.stringify(result)
        var data = new Blob([outString], {type: 'application/json'})
      } else if (datatype === 'TXT') {
        outString = await API.exportCSV(uuid)
        var data = new Blob([outString], {type: 'text/plain'})
      }
      var textFilepath = window.URL.createObjectURL(data)
      return textFilepath
    },
    // provide download information before even requested
    async prepareDownload(uuid) {
      if (this.uuid) {
        this.downloadOptions.forEach(async item => {
          const filepath = await this.download(item.title, uuid)
          item.href = filepath
        })
      }
    }, 
    logout () {
      window.getApp.$emit('APP_LOGOUT')
    },
    showModal (nameOfModal) {
      this.$modal.show(nameOfModal);
    },
    hideModal (nameOfModal) {
      this.$modal.hide(nameOfModal);
    },
    uploadFile () {      
      this.hideModal("upload");
    },
    onSelect(){
      const allowedTypes = ["xls", "xlsx", "application/vnd.ms-excel", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"];
      const file = this.$refs.file.files[0];
      this.file = file;
      this.errorMessage = '';

      if(!allowedTypes.includes(file.type)){
        console.log(file.type);
        this.errorMessage = "Only excel files are allowed";
        this.file = null;
        return false;
      }
      if(file.size > 500000) {
        this.errorMessage = "Too large, max size allowed is 500KB";
        this.file = null;
        return false;
      }
      document.getElementById("nameOfFile").innerText = document.getElementById("inputFile").files[0].name;
      
      
    },
    async onSubmit(){
        if(this.file) {
          const formData = new FormData();
          formData.append('file', this.file);
          try{
            let postResult = await axios.post('api/upload', formData);
            console.log(postResult);
            this.uploadResult = postResult.data.fileName;
            this.uploadResultUrl = postResult.data.fileUrl;
          } catch(err) {
            this.uploadResult = 'Something went wrong';
          }
        }
    },
    async dumpDB(){
      console.log(this.downloadFilter);
      axios({
          url: 'api/download/export/toExcel',
          method: 'POST',
          data: this.downloadFilter,
          responseType: 'blob', // important
        }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          let d = new Date();
          const fileName = "export_" + d.getDate()  + "-" + (d.getMonth()+1) + "-" + d.getFullYear() + "-" + d.getHours() + ":" + d.getMinutes() + ".xlsx";
          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();
        });
    },
    async dumpVendor(){
      console.log(this.downloadFilter);
      axios({
          url: 'api/download/export/vendorStat',
          method: 'POST',
          data: this.downloadFilter,
          responseType: 'blob', // important
        }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          let d = new Date();
          const fileName = "export_" + d.getDate()  + "-" + (d.getMonth()+1) + "-" + d.getFullYear() + "-" + d.getHours() + ":" + d.getMinutes() + ".xlsx";
          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();
        });
    },
    manageUsers(){
      this.$router.push('/users/manageUsers')
    },
    statistics(){
      this.$router.push('/statistics')
    },
    filterWorklists(){
      this.$root.$emit("filter",this.downloadFilter)
      this.hideModal("filter")
    },
    filterWorklistsReset(){
      var today = new Date()
      today.setDate(today.getDate() - 30)
      let fromDate = today.toISOString().split("T")[0]
      this.downloadFilter = {
        toDate: new Date().toISOString().split("T")[0],
        fromDate: fromDate,
        status:'ALL',
        team:'ALL',
        dept: 'ALL'
      }
    },
    changeTeams() {
            console.log(this.downloadFilter.dept);
            if(this.downloadFilter.dept != "All") {
                this.teams = [];
                this.teams.push({"name":"All","id":"All"});
                for(let i = 0; i < this.teamsDept.length; i++) { 
                    if(this.teamsDept[i].dept === this.downloadFilter.dept) {
                        this.teams.push({name:this.teamsDept[i].name,id:this.teamsDept[i].id});
                    }
                }
            } else {
              this.teams = [];
              this.teams.push({"name":"All","id":"All"});
            }
        },
        toggleAdvancedFilter(){
      this.advancedFilter = !this.advancedFilter;
    },
    advancedFiltering(){
      var filter={};
      this.advancedHeaders.forEach(element => {
        if(element.filterType && element.filterValue != ""){
          if((element.filterType == "number" && element.filterOperation != "") || element.filterType == "text"){
            filter[element.value] = element;
          }
        }
      });
      this.$root.$emit("filter", filter);
    },
    resetAdvancedFilter(){
      this.advancedHeaders.forEach(element => {
        if(element.filterOperation){
          element.filterOperation = "";
        }
        element.filterValue = "";
      });
      this.advancedReset = false;
    },
    showResetButton(){
      this.advancedReset = true;
    },
    pickSubStatus(){
      if(this.downloadFilter.status != "ALL"){
        let options = Object.values(this.subStatuses[this.downloadFilter.status]);
        this.showSubStatusesSelector = (options.length > 0) ? true : false; delete this.downloadFilter.subStatus;
        this.subStatusesItems = options;
        this.subStatusesItems.splice(0,0,'ALL');
      }
    },
    msgks(){
      this.$router.push('/msgk/manageMsgks')
    },
    suppliers(){
      this.$router.push('/supplier/manageSuppliers')
    },
    logs(){
      this.$router.push('/logs')
    },
    settings(){
      this.$router.push('/settings')
    },
    feedbacks(){
      this.$router.push('/feedbacks')
    }
  }
}
</script>
<style lang="stylus" scoped>
  .msg-radius
    border-radius: 20px;
</style>
  <style lang="stylus" >
  .chat-room table.v-table {
    white-space: nowrap;
  }
    .messaging--body {
      max-width: 80%;
    }
.picker{
  width: 50%;
  display: inline-flex;
}
</style>
